






























import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

@Component
export default class SignCard extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop() signedAt!: string | null;
  @Prop() name!: string | null;
  @Prop() nip!: string | null;
  @Prop({ default: "Tanda Tangan" }) buttonLabel!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) reason!: string;

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY HH:mm") : "";
  }
}
